<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="pa-3 mb-3">
        <v-row class="mb-4">
          <v-col cols="12" sm="6" lg="3">
            <v-card class="pa-4">
              <div class="d-flex align-end">
                <v-img src="/svg/sales.svg" width="48" style="max-width: 48px !important"></v-img>
                <h5 class="text-00AD11 ml-2">ยอดขาย</h5>
              </div>
              <h1>{{ currencyFormat(parseFloat(get_data.total_sale.current)) }} <span class="fs-16">บาท</span></h1>
              <p v-if="parseFloat(get_data.total_sale.diff) >= 0" class="fs-16">
                <span class="text-00AD11">+{{ currencyFormat(get_data.total_sale.diff) }}%</span> บาทเทียบกันเดือนก่อนหน้า
              </p>
              <p v-else class="fs-16">
                <span class="text-FF1C0D">{{ currencyFormat(get_data.total_sale.diff) }}%</span> เทียบกันเดือนก่อนหน้า
              </p>
              <p class="fs-16">
                เป็นยอดขายจากเดือนก่อนหน้า <b>{{ currencyFormat(parseFloat(get_data.total_sale.last_month)) }}</b> บาท
              </p>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <v-card class="pa-4">
              <div class="d-flex align-end">
                <v-img src="/svg/profit.svg" width="48" style="max-width: 48px !important"></v-img>
                <h5 class="text-F8B200 ml-2">กำไร</h5>
              </div>
              <h1>{{ currencyFormat(parseFloat(get_data.profit.current)) }} <span class="fs-16">บาท</span></h1>
              <p v-if="parseFloat(get_data.profit.diff) >= 0" class="fs-16">
                <span class="text-F8B200">+{{ currencyFormat(get_data.profit.diff) }}%</span> บาทเทียบกันเดือนก่อนหน้า
              </p>
              <p v-else class="fs-16">
                <span class="text-FF1C0D">-{{ currencyFormat(get_data.profit.diff) }}%</span> เทียบกันเดือนก่อนหน้า
              </p>
              <p class="fs-16">
                เป็นยอดกำไรจากเดือนก่อนหน้า <b>{{ currencyFormat(parseFloat(get_data.profit.last_month)) }}</b> บาท
              </p>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" lg="3">
            <v-card class="pa-4">
              <div class="d-flex align-end">
                <v-img src="/svg/num_bill.svg" width="48" style="max-width: 48px !important"></v-img>
                <h5 class="text-068EC2 ml-2">จำนวนบิล</h5>
              </div>
              <h1>{{ get_data.bill.current }} <span class="fs-16">บิล</span></h1>
              <p v-if="get_data.bill.diff >= 0" class="fs-16">
                <span class="text-068EC2">+{{ currencyFormat(get_data.bill.diff) }}</span> บิลเทียบกันเดือนก่อนหน้า
              </p>
              <p v-else class="fs-16">
                <span class="text-FF1C0D">{{ currencyFormat(get_data.bill.diff) }}</span> บิลเทียบกันเดือนก่อนหน้า
              </p>
              <p class="fs-16">
                เป็นบิลเก่าจากเดือนก่อนหน้า <b>{{ get_data.bill.last_month }}</b> บิล
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-card class="pa-4">
              <div class="d-flex align-end">
                <v-img src="/svg/customer.svg" width="48" style="max-width: 48px !important"></v-img>
                <h5 class="text-black ml-2">ลูกค้า</h5>
              </div>
              <h1>{{ get_data.customer.current }} <span class="fs-16">คน</span></h1>
              <p v-if="get_data.customer.diff >= 0" class="fs-16">
                <span class="text-black">+{{ currencyFormat(get_data.customer.diff) }}</span> คนเทียบกันเดือนก่อนหน้า
              </p>
              <p v-else class="fs-16">
                <span class="text-FF1C0D">{{ currencyFormat(get_data.customer.diff) }}</span> คนเทียบกันเดือนก่อนหน้า
              </p>
              <p class="fs-16">
                เป็นลูกค้าเก่าจากเดือนก่อนหน้า <b>{{ get_data.customer.last_month }}</b> คน
              </p>
            </v-card>
          </v-col>
        </v-row>

        <div class="d-flex justify-space-between align-center mb-6">
          <div class="mr-1">
            <v-select label="เลือกประเภทวันที่" :items="list_select_type_data" item-text="name" item-value="id" v-model="type" color="primary" hide-details="auto" outlined> </v-select>
          </div>
          <div class="d-flex option_date_dashboard_list">
            <div>
              <v-select v-if="type == 0" label="เลือกเดือนเริ่มต้น" :items="list_select_month_data" item-text="name" item-value="id" v-model="date_start" color="primary" hide-details="auto" outlined> </v-select>
              <v-select v-else label="เลือกปีเริ่มต้น" :items="list_select_year_data" item-text="name" item-value="id" v-model="date_start" color="primary" hide-details="auto" outlined> </v-select>
            </div>
            <div class="ml-4">
              <v-select v-if="type == 0" label="เลือกเดือนสิ้นสุด" :items="list_select_month_data" item-text="name" item-value="id" v-model="date_end" color="primary" hide-details="auto" outlined> </v-select>
              <v-select v-else label="เลือกปีสิ้นสุด" :items="list_select_year_data" item-text="name" item-value="id" v-model="date_end" color="primary" hide-details="auto" outlined> </v-select>
            </div>
          </div>
        </div>

        <!-- ยอดขายร้านอาหาร -->
        <v-card class="pa-4 mb-8">
          <div class="d-flex align-end mb-4">
            <v-img src="/svg/restaurant_sales.svg" width="48" style="max-width: 48px !important"></v-img>
            <h4 class="ml-4">ยอดขายร้านอาหาร</h4>
          </div>
          <v-row>
            <v-col cols="12" lg="3">
              <v-row>
                <v-col cols="12" sm="6" md="3" lg="12">
                  <v-card class="pa-3 rounded-lg">
                    <div class="d-flex justify-space-between mb-2">
                      <v-img src="/svg/cash.svg" style="max-width: 40px !important"></v-img>
                      <h3 class="text-00AD11">{{ get_data_profit_by_filter.total_sale ? currencyFormat(parseFloat(get_data_profit_by_filter.total_sale)) : currencyFormat(0) }}</h3>
                    </div>
                    <h5 class="text-707070">ยอดขายสุทธิ (บาท)</h5>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="12">
                  <v-card class="pa-3 rounded-lg">
                    <div class="d-flex justify-space-between mb-2">
                      <v-img src="/svg/discounts.svg" style="max-width: 40px !important"></v-img>
                      <h3 class="text-F8B200">{{ get_data_profit_by_filter.total_discount ? currencyFormat(parseFloat(get_data_profit_by_filter.total_discount)) : currencyFormat(0) }}</h3>
                    </div>
                    <h5 class="text-707070">รวมส่วนลดที่ให้ลูกค้า (บาท)</h5>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="12">
                  <v-card class="pa-3 rounded-lg">
                    <div class="d-flex justify-space-between mb-2">
                      <v-img src="/svg/canceled_bills.svg" style="max-width: 40px !important"></v-img>
                      <h3 class="text-FF1C0D">{{ get_data_profit_by_filter.lost_cash ? currencyFormat(parseFloat(get_data_profit_by_filter.lost_cash)) : currencyFormat(0) }}</h3>
                    </div>
                    <h5 class="text-707070">มูลค่าบิลที่ยกเลิก (บาท)</h5>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="12">
                  <v-card class="pa-3 rounded-lg">
                    <div class="d-flex justify-space-between mb-2">
                      <v-img src="/svg/customer_outline.svg" style="max-width: 40px !important"></v-img>
                      <h3 class="text-black">{{ get_data_profit_by_filter.count_customer ? get_data_profit_by_filter.count_customer : 0 }}</h3>
                    </div>
                    <h5 class="text-707070">ยอดลูกค้า (คน)</h5>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col lg="9">
              <v-card class="pa-4">
                <div class="d-flex align-end">
                  <v-img src="/svg/graph_profit.svg" style="max-width: 40px !important"></v-img>
                  <h4 class="ml-4">กราฟแสดงรายได้ร้านอาหาร</h4>
                </div>
                <canvas id="chart-restaurant-income"></canvas>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

        <!-- ยอดรายได้ กำไร ต้นทุน ของร้าน -->
        <v-card class="pa-4 mb-8">
          <div class="d-flex align-end mb-4">
            <v-img src="/svg/costs.svg" width="48" style="max-width: 48px !important"></v-img>
            <h4 class="ml-4">ยอดรายได้ กำไร ต้นทุน ของร้าน</h4>
          </div>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" sm="6" md="3" lg="4">
                  <v-card class="pa-3 rounded-lg" style="border: 1px solid #00ad11">
                    <div class="d-flex justify-space-between mb-3">
                      <v-img src="/svg/cash.svg" style="max-width: 40px !important"></v-img>
                      <h3 class="text-00AD11">{{ get_data_income_by_filter.total_income ? currencyFormat(parseFloat(get_data_income_by_filter.total_income)) : currencyFormat(0) }}</h3>
                    </div>
                    <h5 class="text-707070">รายได้รวม (บาท)</h5>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="4">
                  <v-card class="pa-3 rounded-lg" style="border: 1px solid #f8b200">
                    <div class="d-flex justify-space-between mb-3">
                      <v-img src="/svg/total_profit.svg" style="max-width: 40px !important"></v-img>
                      <h3 class="text-F8B200">{{ get_data_income_by_filter.total_profit ? currencyFormat(parseFloat(get_data_income_by_filter.total_profit)) : currencyFormat(0) }}</h3>
                    </div>
                    <h5 class="text-707070">กำไรรวม (บาท)</h5>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="4">
                  <v-card class="pa-3 rounded-lg" style="border: 1px solid #0c92c6">
                    <div class="d-flex justify-space-between mb-3">
                      <v-img src="/svg/total_cost.svg" style="max-width: 40px !important"></v-img>
                      <h3 class="text-0C92C6">{{ get_data_income_by_filter.cost ? currencyFormat(parseFloat(get_data_income_by_filter.cost)) : currencyFormat(0) }}</h3>
                    </div>
                    <h5 class="text-707070">ต้นทุนรวม (บาท)</h5>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <canvas id="chart-profit-cost"></canvas>
            </v-col>
          </v-row>
        </v-card>

        <!-- รายการอาหารขายดี -->
        <v-card class="pa-4 mb-8">
          <div class="d-flex align-end mb-4">
            <v-img src="/svg/best_food.svg" width="48" style="max-width: 48px !important"></v-img>
            <h4 class="ml-4">รายการอาหารขายดี</h4>
          </div>
          <v-text-field class="mb-4" v-model="search_food_by_filter" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          <v-data-table :headers="headers_best_food" :items="desserts_best_food" hide-default-footer class="elevation-1">
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ index + offset_food_by_filter }}</td>
                <td>{{ item.name }}</td>
                <td align="center">{{ item.category_name }}</td>
                <td align="center">{{ currencyFormat(parseFloat(item.price)) }}</td>
                <td align="center">{{ item.amount }}</td>
                <td align="center">฿ {{ item.amount  * item.price}}</td>
              </tr>
            </template>
          </v-data-table>
          <br />
          <v-pagination v-model="current_page_food_by_filter" :length="page_food_by_filter" :total-visible="7"></v-pagination>
        </v-card>

        <!-- วัตถุดิบที่ใกล้หมด -->
        <v-card class="pa-4 mb-8">
          <div class="d-flex align-end mb-4">
            <v-img src="/svg/stock.svg" width="48" style="max-width: 48px !important"></v-img>
            <h4 class="ml-4">วัตถุดิบที่ใกล้หมด</h4>
          </div>
          <v-text-field class="mb-4" v-model="search_material_less" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          <v-data-table :headers="headers_out_stock" :items="desserts_out_stock" hide-default-footer class="elevation-1">
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ index + offset_material_less }}</td>
                <td>{{ item.name }}</td>
                <td align="center">{{ item.max }} / {{ item.min }}</td>
                <td align="center">{{ item.stock }}</td>
                <td align="center">{{ item.unit_name }}</td>
                <td align="center">
                  <router-link to="/materialnow">
                    <v-img src="/svg/eye.svg" width="30" style="max-width: 30px !important; cursor: pointer"></v-img>
                  </router-link>
                </td>
              </tr>
            </template>
          </v-data-table>
          <br />
          <v-pagination v-model="current_page_material_less" :length="page_material_less" :total-visible="7"></v-pagination>
        </v-card>

        <!-- ตารางแนะนำราคาขาย -->
        <v-card class="pa-4 mb-8">
          <div class="d-flex justify-space-between">
            <div class="d-flex align-end mb-4">
              <v-img src="/svg/stock.svg" width="48" style="max-width: 48px !important"></v-img>
              <h4 class="ml-4">ตารางแนะนำราคาขาย</h4>
            </div>
            <v-select style="max-width: 250px;" label="ทั้งหมด" :items="list_select_price_table" item-text="name" item-value="name" v-model="year" color="primary" hide-details="auto" outlined> </v-select>
          </div>
          <v-text-field class="mb-4" v-model="search_food_price" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          <v-data-table :headers="headers_price_table" :items="desserts_price_table" hide-default-footer class="elevation-1">
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ index + offset_food_price }}</td>
                <td>{{ item.name }}</td>
                <!-- <td align="center">{{ item.unit }}</td> -->
                <td align="center">{{ currencyFormat(parseFloat(item.price)) }}</td>
                <td align="center">{{ item.total_cost == 0 ? '-' : currencyFormat(parseFloat(item.total_cost)) }}</td>
                <td align="center">{{ item.total_price_15 == 0 ? '-' : currencyFormat(parseFloat(item.total_price_15)) }}</td>
                <td align="center">{{ item.total_price_30 == 0 ? '-' : currencyFormat(parseFloat(item.total_price_30)) }}</td>
                <td align="center">{{ item.total_price_50 == 0 ? '-' : currencyFormat(parseFloat(item.total_price_50)) }}</td>
              </tr>
            </template>
          </v-data-table>
          <br />
          <v-pagination v-model="current_page_food_price" :length="page_food_price" :total-visible="7"></v-pagination>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
// import "chartjs-plugin-labels";
import dashboard from "@/api/dashboard/dashboard.js";
import { currencyFormat } from "@/helper/numberformat.js";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  data() {
    return {
      menu1: false,
      menu2: false,
      loading_page: true,
      list_select_price_table: [{ id: 1, name: "ราคาขายต่ำกว่าต้นทุน" }],
      list_select_type_data: [
        { id: 0, name: "เดือน" },
        { id: 1, name: "ปี" },
      ],
      list_select_month_data: [
        { id: 1, name: "มกราคม" },
        { id: 2, name: "กุมภาพันธ์" },
        { id: 3, name: "มีนาคม" },
        { id: 4, name: "เมษายน" },
        { id: 5, name: "พฤษภาคม" },
        { id: 6, name: "มิถุนายน" },
        { id: 7, name: "กรกฎาคม" },
        { id: 8, name: "สิงหาคม" },
        { id: 9, name: "กันยายน" },
        { id: 10, name: "ตุลาคม" },
        { id: 11, name: "พฤศจิกายน" },
        { id: 12, name: "ธันวาคม" },
      ],
      list_select_year_data: [],

      search_out_stock: "",
      search_best_food: "",
      search_price_table: "",

      headers_best_food: [{ text: "#" }, { text: "รายการ" }, { text: "ประเภท", align: "center" }, { text: "ราคา/บาท", align: "center" }, { text: "จำนวนยอดขาย", align: "center" }, { text: "ยอดรวมราคา", align: "center" }],
      desserts_best_food: [],

      headers_out_stock: [
        { text: "#" },
        { text: "รายการ" },
        { text: "Max/min", align: "center" },
        { text: "จำนวนคงเหลือ", align: "center" },
        { text: "หน่วยนับ", align: "center" },
        { text: "ดูรายละเอียด", align: "center" },
      ],
      desserts_out_stock: [],

      headers_price_table: [
        { text: "#" },
        { text: "รายการ" },
        //{ text: "หน่วยนับ", align: "center" },
        { text: "ราคาขายปัจจุบัน", align: "center" },
        { text: "ราคาต้นทุน/หน่วย", align: "center" },
        { text: "15%", align: "center" },
        { text: "30%", align: "center" },
        { text: "50%", align: "center" },
      ],
      desserts_price_table: [],

      get_data: {},
      // Filter data
      type: 0,
      year: new Date().getFullYear(),
      date_start: 1,
      date_end: 12,

      // ตารางแนะนำราคาขาย
      search_food_price: "",
      page_food_price: 1,
      offset_food_price: 1,
      current_page_food_price: 1,
      size_food_price: 10,

      // วัตถุดิบที่ใกล้หมด
      search_material_less: "",
      page_material_less: 1,
      offset_material_less: 1,
      current_page_material_less: 1,
      size_material_less: 10,

      // รายการอาหารขายดี
      search_food_by_filter: "",
      page_food_by_filter: 1,
      offset_food_by_filter: 1,
      current_page_food_by_filter: 1,
      size_food_by_filter: 10,

      // ยอดรายได้ กำไร ต้นทุน ของร้าน
      search_profit_by_filter: "",
      page_profit_by_filter: "",
      size_profit_by_filter: "",
      get_data_profit_by_filter: {},

      // ยอดขายร้านอาหาร
      search_income_by_filter: "",
      page_income_by_filter: "",
      size_income_by_filter: "",
      get_data_income_by_filter: {},

      // กราฟแสดงรายได้ร้านอาหาร
      chart_name_1: null,
      chart_restaurant_income_labels: [],
      chart_restaurant_income_data_total_sale: [],
      chart_restaurant_income_data_total_discount: [],
      chart_restaurant_income_data_lost_cash: [],
      chart_restaurant_income_data_count_customer: [],

      chart_name_2: null,
      chart_profit_cost_labels: [],
      chart_profit_cost_total_income: [],
      chart_profit_cost_total_profit: [],
      chart_profit_cost_cost: [],
    };
  },
  methods: {
    currencyFormat,
    // กราฟแสดงรายได้ร้านอาหาร
    setChartRestaurantIncome() {
      const chart = document.getElementById("chart-restaurant-income");
      const config = {
        type: "bar",
        data: {
          labels: this.chart_restaurant_income_labels,
          datasets: [
            {
              label: "ยอดขายสุทธิ",
              data: this.chart_restaurant_income_data_total_sale,
              backgroundColor: "#00AD11",
            },
            {
              label: "รวมส่วนลดที่ให้ลูกค้า",
              data: this.chart_restaurant_income_data_total_discount,
              backgroundColor: "#F8B200",
            },
            {
              label: "มูลค่าบิลที่ยกเลิก (บาท)",
              data: this.chart_restaurant_income_data_lost_cash,
              backgroundColor: "#FF1C0D",
            },
            {
              label: "ยอดลูกค้า (คน)",
              data: this.chart_restaurant_income_data_count_customer,
              backgroundColor: "#000000",
            },
          ],
        },
        options: {
          responsive: true,
          
        },
      };
      if (this.chart_name_1) {
        this.chart_name_1.destroy();
      }
      this.chart_name_1 = new Chart(chart, config);
    },
    // ยอดรายได้ กำไร ต้นทุน ของร้าน
    // {
    //   label: "กำไร",
    //   data: this.chart_profit_cost_total_profit,
    //   fill: false,
    //   borderColor: "#F8B200",
    //   tension: 0,
    // },
    setChartProfitCost() {
      const chart = document.getElementById("chart-profit-cost");
      const config = {
        type: "line",
        data: {
          labels: this.chart_profit_cost_labels,
          datasets: [
            {
              label: "รายได้",
              data: this.chart_profit_cost_total_income,
              fill: false,
              borderColor: "#00AD11",
              tension: 0,
            },

            {
              label: "ต้นทุน",
              data: this.chart_profit_cost_cost,
              fill: false,
              borderColor: "#0C92C6",
              tension: 0,
            },
          ],
        },
        // options: {
        //   responsive: true,
        //   plugins: {
        //     labels: {
        //       fontSize: "unset",
        //     },
        //   },
        // },
      };
      if (this.chart_name_2) {
        this.chart_name_2.destroy();
      }
      this.chart_name_2 = new Chart(chart, config);
    },

    // destroyChartProfitCost() {
    //   const chart1 = document.getElementById("chart-restaurant-income");
    //   const chart2 = document.getElementById("chart-profit-cost");
    //   const existingChart = Chart.getChart(chart);
    //   const existingChart2 = Chart.getChart(chart2);

    //   // ตรวจสอบว่า Chart มีอยู่หรือไม่ก่อนที่จะลบ
    //   if (existingChart1) {
    //     existingChart1.destroy();
    //   }
    // },

    //
    async getData() {
      const data = await dashboard.dashboardNew();
      this.get_data = await data.data;
      this.loading_page = false;
    },

    // ตารางแนะนำราคาขาย
    async getDataFoodPrice() {
      const data = await dashboard.dashboardFoodPrice(this.search_food_price, this.current_page_food_price, this.size_food_price);
      this.desserts_price_table = data.data.data;
      this.page_food_price = data.data.pages;
      this.offset_food_price = data.data.offset;

      // console.log("ตารางแนะนำราคาขาย");
      // console.log(data.data.data);
    },
    // วัตถุดิบที่ใกล้หมด
    async getDataMaterialLess() {
      const data = await dashboard.dashboardMaterialLess(this.search_material_less, this.current_page_material_less, this.size_material_less);
      this.desserts_out_stock = data.data.data;
      this.page_material_less = data.data.pages;
      this.offset_material_less = data.data.offset;

      // console.log("วัตถุดิบที่ใกล้หมด");
      // console.log(data);
    },

    // รายการอาหารขายดี
    async getDataFoodByFilter() {
      const data = await dashboard.dashboardFoodByFilter(this.search_food_by_filter, this.current_page_food_by_filter, this.size_food_by_filter, this.type, this.year, this.date_start, this.date_end);
      this.desserts_best_food = data.data.data;
      this.page_food_by_filter = data.data.pages;
      this.offset_food_by_filter = data.data.offset;
      // console.log("รายการอาหารขายดี");
      // console.log(data);
    },

    // ยอดขายร้านอาหาร
    async getDataProfitByFilter() {
      const data = await dashboard.dashboardProfitByFilter(this.search_profit_by_filter, this.current_page_profit_by_filter, this.size_profit_by_filter, this.type, this.year, this.date_start, this.date_end);
      this.get_data_profit_by_filter = data.data;

      this.chart_restaurant_income_labels = [];
      this.chart_restaurant_income_data_total_sale = [];
      this.chart_restaurant_income_data_total_discount = [];
      this.chart_restaurant_income_data_lost_cash = [];
      this.chart_restaurant_income_data_count_customer = [];

      this.get_data_profit_by_filter.data.map((v) => {
        this.chart_restaurant_income_labels = [...this.chart_restaurant_income_labels, v.name];
        this.chart_restaurant_income_data_total_sale = [...this.chart_restaurant_income_data_total_sale, v.total_sale];
        this.chart_restaurant_income_data_total_discount = [...this.chart_restaurant_income_data_total_discount, v.total_discount];
        this.chart_restaurant_income_data_lost_cash = [...this.chart_restaurant_income_data_lost_cash, v.lost_cash];
        this.chart_restaurant_income_data_count_customer = [...this.chart_restaurant_income_data_count_customer, v.count_customer];
      });

      // console.log("กำไร");
      // console.log(data);
    },

    // ยอดรายได้ กำไร ต้นทุน ของร้าน
    async getDataIncomeByFilter() {
      const data = await dashboard.dashboardIncomeByFilter(this.search_income_by_filter, this.current_page_income_by_filter, this.size_income_by_filter, this.type, this.year, this.date_start, this.date_end);
      this.get_data_income_by_filter = data.data;
      this.chart_profit_cost_labels = [];
      this.chart_profit_cost_total_income = [];
      this.chart_profit_cost_total_profit = [];
      this.chart_profit_cost_cost = [];
      this.get_data_income_by_filter.data.map((v) => {
        this.chart_profit_cost_labels = [...this.chart_profit_cost_labels, v.name];
        this.chart_profit_cost_total_income = [...this.chart_profit_cost_total_income, v.total_income];
        this.chart_profit_cost_total_profit = [...this.chart_profit_cost_total_profit, v.total_profit];
        this.chart_profit_cost_cost = [...this.chart_profit_cost_cost, v.cost];
      });

      // console.log("ยอดขายร้านอาหาร");
      // console.log(data);
    },

    async setYear() {
      const currentYear = new Date().getFullYear();
      this.date_start = currentYear;
      this.date_end = currentYear;
      for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        this.list_select_year_data.push({ id: year, name: year });
      }
    },
  },
  computed: {},
  async mounted() {
    await this.getData();
    await this.getDataFoodPrice();
    await this.getDataMaterialLess();
    await this.getDataFoodByFilter();
    await this.getDataProfitByFilter();
    await this.getDataIncomeByFilter();

    await this.setChartRestaurantIncome();
    await this.setChartProfitCost();
  },
  watch: {
    async search_food_price() {
      this.current_page_food_price = 1;
      await this.getDataFoodPrice();
    },
    async search_material_less() {
      this.current_page_material_less = 1;
      await this.getDataMaterialLess();
    },
    async search_food_by_filter() {
      this.current_page_food_by_filter = 1;
      await this.getDataFoodByFilter();
    },
    // async search_profit_by_filter() {
    //   this.current_page_profit_by_filter = 1;
    //   await this.getDataProfitByFilter();
    // },
    // async search_income_by_filter() {
    //   this.current_page_income_by_filter = 1;
    //   await this.getDataIncomeByFilter();
    // },

    async current_page_food_price() {
      await this.getDataFoodPrice();
    },
    async current_page_material_less() {
      await this.getDataMaterialLess();
    },
    async current_page_food_by_filter() {
      await this.getDataFoodByFilter();
    },

    async type() {
      if (this.type == 1) {
        await this.setYear();
      } else {
        this.date_start = 1;
        this.date_end = 12;
      }
      await this.getDataProfitByFilter();
      await this.getDataIncomeByFilter();
      await this.getDataFoodByFilter();

      await this.setChartRestaurantIncome();
      await this.setChartProfitCost();
      // console.log(this.type);
    },
    async date_start() {
      await this.getDataProfitByFilter();
      await this.getDataIncomeByFilter();
      await this.getDataFoodByFilter();

      await this.setChartRestaurantIncome();
      await this.setChartProfitCost();
    },
    async date_end() {
      await this.getDataProfitByFilter();
      await this.getDataIncomeByFilter();
      await this.getDataFoodByFilter();

      await this.setChartRestaurantIncome();
      await this.setChartProfitCost();
    },
  },
};
</script>

<style scoped>
.fs-16 {
  font-size: 16px;
}

.text-00AD11 {
  color: #00ad11;
}

.text-F8B200 {
  color: #f8b200;
}

.text-068EC2 {
  color: #068ec2;
}
.text-0C92C6 {
  color: #0c92c6;
}

.text-FF1C0D {
  color: #ff1c0d;
}

.text-707070 {
  color: #707070;
}

.text-black {
  color: black;
}
</style>
